<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Deudores</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Agregar deudor</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItem.name" label="Nombre"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="8">
                    <!--<v-text-field v-model="editedItem.departamento" label="Departameno"></v-text-field>-->
                     <v-select
                v-model="editedItem.departamento"
                :items="deptos"
                label="Departamento"
                data-vv-name="select"
                required></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete 
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>
<script>
import axios from "axios";
import router from '../router/index.js'

  export default {
    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Deudor',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        { text: 'Departamento', value: 'departamento' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        departamento: 0
      },
      defaultItem: {
        name: '',
        departamento: 0,
      },
       deptos: ['4PL',
'AEREO',
'AEROSPACE',
'ALMACEN',
'CONTABILIDAD',
'CONTROLLING',
'CYC',
'FINANZAS',
'IT',
'MANAGEMENT',
'MARITIMO',
'OIL & GAS',
'OPERACIONES',
'OPERACIONES SLP',
'OPERACIONES GDL',
'PRICING',
'REGIONAL',
'RH ',
'TERRESTRE',
'VENTAS']
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar deudor' : 'Modificar deudor'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.desserts = [
          {
            name: 'SERGIO DAVILA NAJERA',
            departamento: 'ALMACEN',
          },
         {
            name: 'BENJAMIN	HERNANDEZ MARTINEZ',
            departamento: 'CONTABILIDAD',
          },
           {
            name: 'KARLA ELIZABETH RESENDIZ MARTINEZ',
            departamento: 'CONTROLLING',
          },
           {
            name: 'ANAHI YOCABETH DOMINGUEZ SERRANO',
            departamento: 'FINANZAS',
          },
           {
            name: 'BENJAMIN	HERNANDEZ MARTINEZ',
            departamento: 'CONTABILIDAD',
          },
            {
            name: 'SERGIO DAVILA NAJERA',
            departamento: 'ALMACEN',
          },
         {
            name: 'BENJAMIN	HERNANDEZ MARTINEZ',
            departamento: 'CONTABILIDAD',
          },
           {
            name: 'KARLA ELIZABETH RESENDIZ MARTINEZ',
            departamento: 'CONTROLLING',
          },
           {
            name: 'ANAHI YOCABETH DOMINGUEZ SERRANO',
            departamento: 'FINANZAS',
          },
        ]
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Estas seguro de eliminar este registro?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
    mounted(){
      //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          //console.log(response.data.message);
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios
    }
  }
</script>